import { FETCH_PAGINATED_EQUIPMENTS, FETCH_ALL_EQUIPMENTS, EQUIPMENT_QUERY } from '../../mutation-types';

export default {
  [FETCH_PAGINATED_EQUIPMENTS](state, { equipments, pagination }) {
    state.items = equipments;
    state.pagination = pagination;
  },

  [FETCH_ALL_EQUIPMENTS](state, equipment) {
    state.all = equipment;
  },

  [EQUIPMENT_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/equipment/mutations.js